import * as Animate from "react-reveal";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import { ArrowUpRight } from "../../../components/svgs";
import NucleusImg from "../../../assets/images/png/nucleus.jpeg";

const NucleusHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      id="top"
      style={{
        backgroundImage: "linear-gradient(#fff 0%, #f7f9ff 100%)",
      }}
    >
      <HeaderNavigation />
      <GroupSubNav />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center">
          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-2">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                The Nucleus by Utiva
              </p>
              <p className="text-gray font-poppins text-sm mb-6">
                Grow with Utiva
              </p>

              <h1 className="text-4xl md:text-5xl max-w-xl lg:text-business-hero font-poppins tracking-[-0.03em] leading-[1.1] font-bold mb-7 text-primary">
                Premium tech learning, even when the internet is{" "}
                <mark
                  className="bg-secondary text-primary px-2 inline-block"
                  style={{
                    boxDecorationBreak: "clone",
                    WebkitBoxDecorationBreak: "clone",
                  }}
                >
                  not available.
                </mark>
              </h1>

              <p className="font-poppins text-lg md:text-lg text-gray leading-relaxed mb-9 max-w-xl">
                The Nucleus brings curated, self-paced technology courses to
                learners in remote regions through an offline learning device.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg">
                <a
                  href="mailto:nucleus@utiva.io?subject=Order The Nucleus"
                  className="text-white bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center font-bold shadow-course-feature focus:outline-none"
                >
                  Order The Nucleus
                  <span className="ml-2">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </a>
                <a
                  href="#model"
                  className="text-primary text-base font-poppins font-bold underline decoration-secondary decoration-2 underline-offset-4 hover:opacity-80 transition-all"
                >
                  Explore the model ↓
                </a>
              </div>
            </Animate.Fade>
          </div>

          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "580px" }}
              >
                <img
                  src={NucleusImg}
                  alt="A learner using The Nucleus offline learning device"
                  className="absolute inset-0 w-full h-full object-cover"
                />

                <div
                  className="absolute z-10 bottom-7 left-7 right-7 rounded-2xl p-6 md:p-7"
                  style={{ background: "rgba(3,4,71,0.92)" }}
                >
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-3 font-poppins">
                    Learn offline
                  </p>
                  <h2 className="text-white text-xl md:text-2xl font-poppins font-extrabold leading-tight m-0">
                    A different delivery model for communities the internet does
                    not reach reliably.
                  </h2>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NucleusHeaderSection;
